import { SequenceManagerAction } from "./SequenceManagerAction";

const SimOptionAction = {
  SELECT_SIM_TYPE : "SELECT_SIM_TYPE",
} as const;

const simSelection = (selection: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: SimOptionAction.SELECT_SIM_TYPE, payload: {selection:selection, offerContainerId: offerContainerId} });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['SimOption'] });
  };
};

export { SimOptionAction, simSelection };
